'use client';
import React from 'react';
import { useModel } from '@/context/ModelContext';
import { fmtNum } from '@/lib/financial-model';
import InputRow from './InputRow';

export default function VariableCostsSection() {
  const { assumptions, updateAssumption, model } = useModel();

  return (
    <div>
      <InputRow
        label="Raw Material (Delivered)"
        unit="₹ / tonne pellet"
        note="Biomass feedstock delivered to gate — parali, bagasse, agri-residue mix — Western UP 2026"
        confidence="Medium"
        value={assumptions?.rawMaterialCost}
        onChange={(v) => updateAssumption('rawMaterialCost', v)}
        min={1000}
        max={5000}
        step={50}
      />
      <InputRow
        label="Power (Grid — No Solar)"
        unit="₹ / tonne pellet"
        note="~0.14 kWh/kg × ₹8/unit grid tariff; higher without solar integration"
        confidence="Medium"
        value={assumptions?.powerCost}
        onChange={(v) => updateAssumption('powerCost', v)}
        min={400}
        max={3000}
        step={50}
      />
      <InputRow
        label="Labour (Direct)"
        unit="₹ / tonne pellet"
        note="Slightly lower per tonne at 5 TPH scale vs 2 TPH — scale economies on direct operators"
        confidence="Medium"
        value={assumptions?.labourCost}
        onChange={(v) => updateAssumption('labourCost', v)}
        min={100}
        max={1000}
        step={10}
      />
      <InputRow
        label="Maintenance & Spares"
        unit="₹ / tonne pellet"
        note="Dies, rollers, wear parts — economies of scale at 5 TPH"
        confidence="Medium"
        value={assumptions?.maintenanceCost}
        onChange={(v) => updateAssumption('maintenanceCost', v)}
        min={50}
        max={1000}
        step={10}
      />
      <InputRow
        label="Packaging"
        unit="₹ / tonne pellet"
        note="HDPE/PP bags for pellet packing"
        confidence="High"
        value={assumptions?.packagingCost}
        onChange={(v) => updateAssumption('packagingCost', v)}
        min={50}
        max={500}
        step={10}
      />
      <InputRow
        label="Other Variable (Transport Internal etc.)"
        unit="₹ / tonne pellet"
        note="Internal logistics, water, consumables — scale benefit vs 2 TPH"
        confidence="Medium"
        value={assumptions?.otherVariableCost}
        onChange={(v) => updateAssumption('otherVariableCost', v)}
        min={0}
        max={500}
        step={10}
      />
      <InputRow
        label="Total Variable Cost per Tonne"
        unit="₹ / tonne"
        note="Calculated: SUM of all 6 variable cost lines above"
        isCalculated
        calculatedValue={`₹${fmtNum(model?.totalVariableCostPerTonne)}`}
        value={model?.totalVariableCostPerTonne}
        onChange={() => {}}
      />
      <div className="mt-3 p-3 bg-muted/50 rounded-lg">
        <p className="text-xs text-muted-foreground">
          Contribution Margin / Tonne:{' '}
          <span className="font-mono font-semibold text-foreground">
            ₹{fmtNum(assumptions?.sellingPrice - model?.totalVariableCostPerTonne)}
          </span>
          {' · '}
          Gross Margin (Yr2):{' '}
          <span className="font-mono font-semibold text-primary">
            {model?.years?.[2] ? (model?.years?.[2]?.grossMarginPct * 100)?.toFixed(1) : '—'}%
          </span>
        </p>
      </div>
    </div>
  );
}
